import {
  CatalogueVariant,
  hasVariantLanguage,
} from '@/client/campaigns/types/catalogue.type';
import {
  getPhishingLanguageCode,
  getPhishingLanguageLabel,
} from '@/utils/helpers';
import { resolveTextDirection } from '@/utils/helpers/language.helper';
import { Tooltip } from 'primereact/tooltip';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  LanguageBadge,
  LanguageBadgesContainer,
} from './LanguageBadges.styled';

type LanguageBadgesProps = {
  variants: CatalogueVariant[];
  max?: number;
};

export const LanguageBadges = ({
  variants: allVariants,
  max = 3,
}: LanguageBadgesProps) => {
  const { t, i18n } = useTranslation();
  const moreRef = useRef<HTMLSpanElement>(null);
  const variants = allVariants.filter(hasVariantLanguage);

  if (!variants.length) {
    return null;
  }

  const visible = variants.slice(0, max);
  const hiddenCount = variants.length - visible.length;
  const allLabels = variants.map(({ language }) =>
    getPhishingLanguageLabel(language),
  );

  return (
    <LanguageBadgesContainer>
      {visible.map(({ templateId, language }) => (
        <LanguageBadge key={templateId}>
          {getPhishingLanguageCode(language)}
        </LanguageBadge>
      ))}
      {hiddenCount > 0 && (
        <>
          <LanguageBadge
            ref={moreRef}
            tabIndex={0}
            aria-label={allLabels.join(', ')}
          >
            {t('campaign.catalogue.languages.more', { count: hiddenCount })}
          </LanguageBadge>
          <Tooltip
            target={moreRef}
            position="top"
            event="both"
            content={allLabels.join(', ')}
            pt={{ root: { dir: resolveTextDirection(i18n?.language) } }}
          />
        </>
      )}
    </LanguageBadgesContainer>
  );
};
